export enum ExecutionLogStatus {
  Sent = "Sent",
  Failed = "Failed",
}
